// extracted by mini-css-extract-plugin
export default {"text":"ChildrenModeHeroCityGreeting_text__wj5s-"};